var React = require('react');

function Details (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#253e8f","key":0}),React.createElement("rect",{"rx":"32","ry":"32","x":"112","y":"80","width":"288","height":"352","fill":"#fff","key":1}),React.createElement("g",{"fill":"#5875d4","key":2},React.createElement("path",{"d":"M144 352h48v48h-48zM144 112h48v48h-48zM144 192h48v48h-48zM144 272h48v48h-48zM224 112h144v48H224zM224 192h112v48H224zM224 272h128v48H224zM224 352h96v48h-96z"}))]);
}

Details.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Details;

Details.default = Details;
